import React, { useState, useEffect } from 'react';
import { Spin, Alert, Card, Tabs } from 'antd';
import '../../css/JuanIS/JuanISFlowchart.css';

const { TabPane } = Tabs;

function JuanISFlowchart() {
  const [flowchartData, setFlowchartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userStrand, setUserStrand] = useState('');

  useEffect(() => {
    const fetchFlowchart = async () => {
      try {
        // Placeholder: Get user's strand from localStorage
        const strand = localStorage.getItem('academicStrand') || 'STEM'; // Fallback to 'STEM' for demo
        setUserStrand(strand);

        if (!strand) {
          throw new Error('No strand information found');
        }

        // Placeholder: Simulated API call for flowchart data
        const response = await new Promise((resolve) =>
          setTimeout(() => {
            resolve({
              ok: true,
              json: () =>
                Promise.resolve({
                  'Grade 11': {
                    'First Term': [
                      { subjectCode: 'MATH101', subjectName: 'General Mathematics', classification: 'Core' },
                      { subjectCode: 'ENG101', subjectName: 'Oral Communication', classification: 'Core' },
                    ],
                    'Second Term': [
                      { subjectCode: 'SCI101', subjectName: 'Earth Science', classification: 'Core' },
                      { subjectCode: 'PE101', subjectName: 'Physical Education', classification: 'Applied' },
                    ],
                  },
                  'Grade 12': {
                    'First Term': [
                      { subjectCode: 'MATH201', subjectName: 'Statistics and Probability', classification: 'Core' },
                      { subjectCode: 'ENG201', subjectName: 'Reading and Writing', classification: 'Core' },
                    ],
                    'Second Term': [
                      { subjectCode: 'SCI201', subjectName: 'Physics', classification: 'Core' },
                      { subjectCode: 'CS101', subjectName: 'Introduction to Computing', classification: 'Specialized' },
                    ],
                  },
                }),
            });
          }, 1000)
        );

        if (!response.ok) {
          throw new Error('Failed to fetch flowchart data');
        }

        const data = await response.json();
        setFlowchartData(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching flowchart:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchFlowchart();
  }, []);

  if (loading) {
    return (
      <div className="juanis-flowchart-loading">
        <Spin size="large" />
        <p>Loading flowchart...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error"
        description={error}
        type="error"
        showIcon
        className="juanis-flowchart-error"
      />
    );
  }

  const gradeLevels = flowchartData ? Object.keys(flowchartData).sort() : [];

  return (
    <div className="juanis-flowchart-container">
      <div className="juanis-flowchart-header">
        <h1>Academic Flowchart - {userStrand}</h1>
        <p>Your academic journey and subject progression</p>
      </div>

      <Tabs defaultActiveKey="0" type="card" className="juanis-flowchart-grade-tabs">
        {gradeLevels.map((gradeLevel, index) => (
          <TabPane tab={gradeLevel} key={index}>
            <div className="juanis-flowchart-semester-grid">
              {Object.entries(flowchartData[gradeLevel]).map(([term, subjects], termIndex) => (
                <Card 
                  key={termIndex}
                  title={`${term}`}
                  className="juanis-flowchart-semester-card"
                  headStyle={{ 
                    backgroundColor: '#00245A',
                    color: 'white',
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px',
                  }}
                >
                  <div className="juanis-flowchart-subjects-list">
                    {subjects.map((subject, subjectIndex) => (
                      <div key={subjectIndex} className="juanis-flowchart-subject-item">
                        <div className="juanis-flowchart-subject-code">{subject.subjectCode}</div>
                        <div className="juanis-flowchart-subject-name">{subject.subjectName}</div>
                        <div className="juanis-flowchart-subject-classification">{subject.classification}</div>
                      </div>
                    ))}
                  </div>
                </Card>
              ))}
            </div>
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
}

export default JuanISFlowchart;